import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { DrupalRESTService } from './drupal-rest.service';
import { Observable, tap, switchMap, of } from 'rxjs';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class AuthRESTService {

  constructor(
    private _drupalRESTService: DrupalRESTService,
    private _authService: AuthService,
    ) { }

  test_login(): Observable<any> {
    let endpoint = "/api_rest/v1/test_login";

    return this._drupalRESTService.httpGET(endpoint).pipe(
      tap(data => {
        if (data && data.success !== false) {
          // Store auth data
          if (data.current_user) {
            this._authService.current_user = data.current_user;
          }
          if (data.csrf_token) {
            this._authService.csrf_token = data.csrf_token;
          }
          if (data.logout_token) {
            this._authService.logout_token = data.logout_token;
          }

          // Set authenticated flag
          this._authService.set_user_authenticated(true);

          // Set initial studios
          if (data.studios && Array.isArray(data.studios) && data.studios.length > 0) {
            this._authService.studios = data.studios;

            // Set initial selected studio if it's available
            if (!this._authService.selectedStudio && data.studios.length > 0) {
              this._authService.selectedStudio = data.studios[0];
            }
          }

          // Load the complete studio list
          this.loadUserStudios();
        }
      })
    );
  }

  /**
   * Load studios associated with the current user
   */
  loadUserStudios(): void {
    if (this._authService.is_user_authenticated()) {
      LoggerService.log('Auth service loading studios list');
      this._drupalRESTService.httpGET('/api_rest/v1/loadStudioList').subscribe({
        next: (data: any) => {
          LoggerService.log('Auth service received studios from API:', data);
          if (data && Array.isArray(data) && data.length > 0) {
            // Update the full list of studios
            this._authService.studios = data;

            // If there's no selected studio, set the first one as selected
            if (!this._authService.selectedStudio && data.length > 0) {
              this._authService.selectedStudio = data[0];
            }
          } else {
            LoggerService.warn('Studio data from API is not an array or is empty');
          }
        },
        error: (error) => {
          LoggerService.error('Error loading studios in auth service:', error);
        }
      });
    }
  }

  login(username: any, password: any) {
    let endpoint = "/api_rest/v1/user_login";

    let body = {
      name: username,
      pass: password,
    };

    let params = [
      {
        parameter: '_format',
        value: 'json',
      },
    ];

    return this._drupalRESTService.httpPOST(endpoint, body, params);
  }

  logout() {
    // let endpoint = '/user/logout';
    let endpoint = '/api_rest/v1/user_logout';

    let params = [
      {
        parameter: '_format',
        value: 'json',
      },
      {
        parameter: 'token',
        value: this._authService.logout_token
      }
    ]

    return this._drupalRESTService.httpGET(endpoint, params);
  }

  register() {

  }

  forgot_password(name: any) {
    let endpoint = '/api_rest/v1/forgot_password';

    let body = {
      name: name,
    };

    let params = [
      {
        parameter: '_format',
        value: 'json',
      },
    ];

    return this._drupalRESTService.httpPOST(endpoint, body, params);
  }

  reset_password(uid: string, timestamp: string, hash: string, new_pass: string) {
    let endpoint = '/api_rest/v1/reset_password';

    let body = {
      uid: uid,
      timestamp: timestamp,
      hash: hash,
      new_pass: new_pass,
    };

    let params = [
      {
        parameter: '_format',
        value: 'json',
      },
    ];

    return this._drupalRESTService.httpPOST(endpoint, body, params);
  }

  checkLicenseAgreementStatus(username: string) {
    let endpoint = "/api_rest/v1/check_license_agreement_status";

    let body = {
      name: username
    };

    let params = [
      {
        parameter: '_format',
        value: 'json',
      },
    ];

    return this._drupalRESTService.httpPOST(endpoint, body, params);
  }

}
